/* eslint-disable */
import React, { useEffect } from "react"
import { useStoryblok } from "../utils/storyblok"
import { sbEditable } from "@storyblok/storyblok-editable"
import { useLocation } from "@reach/router"

import {
  FaFacebookF,
  FaInstagram,
  FaVimeoV,
  FaTwitter,
  FaYoutube,
  FaTiktok,
} from "react-icons/fa"
import KlaviyoNewsletter from "../components/klaviyoNewsletter/klaviyoNewsletter"
import ProductCard from "../components/ProductCard"
import { graphql } from "gatsby"

import Seo from "../components/seo"
import DynamicComponents from "../components/DynamicComponents"
import * as style from "./index.module.scss"
import { Link } from "gatsby"

import Carousel from "react-multi-carousel"
import "react-multi-carousel/lib/styles.css"
import IndexImageCarouselArrow from "../components/IndexImageCarouselArrow"

import SecondaryButton from "../components/SecondaryButton"
import { useStaticQuery } from "gatsby"

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 1024 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 1023, min: 768 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 767, min: 0 },
    items: 1,
    partialVisibilityGutter: 100,
  },
}

// const IndexPage = ({ data }) => {
//   let story = data.storyblokEntry;
//   story = useStoryblok(story,);
//   const storyContent = story.content;

const IndexPage = ({ pageContext, props }) => {
  const { storyblokEntry, productCardsData } = pageContext
  const location = useLocation()

  const navBarQuery = useStaticQuery(graphql`
    query navBarQuery {
      storyblokEntry(slug: { eq: "nav-v4" }) {
        id
        name
        content
        slug
        full_slug
        uuid
        created_at
      }
    }
  `)
  const story = storyblokEntry
    ? useStoryblok(storyblokEntry)
    : { content: null }
  const navBarData = navBarQuery?.storyblokEntry
    ? useStoryblok(navBarQuery.storyblokEntry)
    : { content: null }
  const [facebook, instagram, youtube, vimeo, twitter, tiktok] =
    navBarData.content?.social_links || []
  const GearUpSliderItem =
    story.content && story.content["gear_up_slider"]
      ? story.content["gear_up_slider"].map(blok => (
          <>
            {blok ? (
              <div
                {...sbEditable(blok)}
                className="relative w-full h-full !text-sm"
              >
                <DynamicComponents blok={blok} key={blok._uid} />
              </div>
            ) : null}
          </>
        ))
      : null

  const productHighlights =
    story.content && story.content["product_highlight"]
      ? story.content["product_highlight"].map(blok => (
          <>
            {blok ? (
              <div {...sbEditable(blok)} className="relative">
                <DynamicComponents blok={blok} key={blok._uid} />
              </div>
            ) : null}
          </>
        ))
      : null

  const ExploreCollection =
    story.content && story.content["explore_collection"]
      ? story.content["explore_collection"].map(blok => (
          <>
            {blok ? (
              <div {...sbEditable(blok)} className="relative">
                <DynamicComponents blok={blok} key={blok._uid} />
              </div>
            ) : null}
          </>
        ))
      : null

  const productHighlightsBelow =
    story.content && story.content["product_highlight_below"]
      ? story.content["product_highlight_below"].map(blok => (
          <>
            {blok ? (
              <div {...sbEditable(blok)} className="relative">
                <DynamicComponents blok={blok} key={blok._uid} />
              </div>
            ) : null}
          </>
        ))
      : null

  const FeaturedCollectionItem =
    story.content && story.content["featured_collections"]
      ? story.content["featured_collections"].map(blok => (
          <>
            {blok ? (
              <div {...sbEditable(blok)} className="relative">
                <DynamicComponents blok={blok} key={blok._uid} />
              </div>
            ) : null}
          </>
        ))
      : null

  // Load Yotpo Reviews Script
  useEffect(() => {
    const script = document.createElement("script")
    script.src =
      "https://staticw2.yotpo.com/qNmEg7HN0QiYfqn6n5DHRUGCtTUGNWa1GfSVsHRS/widget.js"
    script.async = true
    document.head.appendChild(script)

    script.onload = e => {
      window.yotpo.refreshWidgets()
    }

    return () => {
      script.remove()
    }
  })

  return (
    <>
      <Seo title="PolarPro®" />
      {/* bf promo banner index */}

      <div className={style.indexHomepage}>
        <div
          className={`${style.polarproIndexHero} relative flex flex-col items-center justify-end md:justify-center`}
        >
          {/* <video width="100%" height="100%" autoPlay muted loop playsInline className="hidden sm:hidden md:block">
            <source src={story.content.desktop_hero_video} type="video/webm" />
            Your browser does not support the video tag.
          </video> */}
          <img
            src={story.content.mobile_hero_image}
            alt=""
            className="relative sm:block md:hidden w-screen m-0"
          />
          <img
            src={story.content.desktop_hero_image}
            alt=""
            className="relative hidden sm:hidden md:block w-screen m-0"
          />
          {/* <video width="100%" height="100%" autoPlay muted loop playsInline className="block sm:block md:hidden">
            <source src={story.content.mobile_hero_video} type="video/webm" />
            Your browser does not support the video tag.
          </video> */}
          <div
            className={`${style.overlayHero} absolute text-white pl-[20px] md:pl-0 w-[100%] md:w-[75vw] pb-40 md:pb-0`}
          >
            <div className="tag bg-paloverde text-white font-bold text-sm inline-block px-4 pb-[2px] pt-[7px] rounded-tl-lg rounded-br-lg">
              {story.content.new}
            </div>
            <div className="title font-black text-3xl md:text-5xl mt-4">
              {story.content.title}
            </div>
            <div className="sub-title font-expanded text-sm lg:text-md">
              {story.content.sub_title}
            </div>
            <div className="mt-3">
              <SecondaryButton
                text={story.content.shop_now}
                link={story.content.link_to}
                buttonStyle="white"
              />
            </div>
          </div>
        </div>
        {/* default */}
        <div
          className={`${style.polarproIndexHero} hidden relative flex flex-col items-center justify-end md:justify-center`}
        >
          {/* <video width="100%" height="100%" autoPlay muted loop playsInline className="hidden sm:hidden md:block">
            <source src={story.content.desktop_hero_video} type="video/webm" />
            Your browser does not support the video tag.
          </video> */}
          <img
            src="https://cdn.shopify.com/s/files/1/1050/9944/files/LCP14-INDEX-LAUNCH-BANNER-MOBILE.webp?v=1665452085"
            alt=""
            className="relative sm:block md:hidden w-screen m-0"
          />
          <img
            src="https://cdn.shopify.com/s/files/1/1050/9944/files/LCP14-INDEX-LAUNCH-BANNER-DESKTOP.webp?v=1665452086"
            alt=""
            className="relative hidden sm:hidden md:block w-screen m-0"
          />
          {/* <video width="100%" height="100%" autoPlay muted loop playsInline className="block sm:block md:hidden">
            <source src={story.content.mobile_hero_video} type="video/webm" />
            Your browser does not support the video tag.
          </video> */}
          <div
            className={`${style.overlayHero} absolute text-white pl-[20px] md:pl-0 w-[100%] md:w-[75vw] pb-40 md:pb-0`}
          >
            <div className="tag bg-paloverde text-white font-bold text-sm inline-block px-4 pb-[2px] pt-[7px] rounded-tl-lg rounded-br-lg">
              New
            </div>
            <div className="title font-black text-3xl md:text-5xl mt-4">
              {story.content.title}
            </div>
            {/* <div className='sub-title font-expanded text-sm lg:text-md'>{story.content.sub_title}</div> */}
            <div className="sub-title font-expanded text-xs lg:text-md">
              Unleash the full production potential of iPhone® 14.
            </div>
            <div className="mt-3">
              <SecondaryButton
                text="Shop Now"
                link={story.content.link_to}
                buttonStyle="white"
              />
            </div>
          </div>
        </div>
        <div
          className={`${style.gearUpCtaSlider} flex flex-col sm:flex-col lg:flex-row overflow-hidden py-24 md:py-12`}
        >
          <div
            className={`${style.tagLine} lg:w-3/12 items-center justify-left md:justify-center flex pl-[20px] md:pl-0 lg:pl-28 mb-24 md:mb-12`}
          >
            <h3 className="font-black text-obsidian text-4xl md:text-3xl xl:text-3xl 2xl:text-5xl m-0">
              {
                story.content.gear_up_description?.content?.[0]?.content?.[0]
                  ?.text
              }
              <span className="text-paloverde">
                {
                  story.content.gear_up_description?.content?.[0]?.content?.[1]
                    ?.text
                }
              </span>
            </h3>
          </div>
          <div
            className={`${style.slider} relative lg:w-9/12 left-[0vw] lg:left-[6vw]`}
          >
            <Carousel
              responsive={responsive}
              swipeable={true}
              draggable={false}
              infinite={true}
              removeArrowOnDeviceType={["mobile"]}
              containerClass={style.sliderContainer}
              autoPlay
              autoPlaySpeed={3000}
              customRightArrow={<IndexImageCarouselArrow right />}
              customLeftArrow={<IndexImageCarouselArrow right={false} />}
            >
              {GearUpSliderItem}
            </Carousel>
          </div>
        </div>

        {/* product highlight */}
        {productHighlights}

        <div className={`${style.threadOnCamera} bg-[#f6f6f6] pt-20`}>
          <h2 className="text-center text-obsidian text-4xl font-black mt-0 mb-14">
            {story.content.product_highlight_description}
          </h2>
          <div
            className={`${style.threadOnCameraContainer} flex flex-col lg:flex-row`}
          >
            <div
              className={`${style.products} lg:w-9/12 flex flex-col md:flex-row h-auto mb-0 lg:mb-20`}
            >
              {/* explore collection */}
              {productCardsData.map(product => (
                <ProductCard product={product} />
              ))}
            </div>
            <div
              className={`${style.tagLine} lg:w-3/12 items-start pt-24 md:pt-10 lg:pt-10 pb-24 flex px-12 flex-col`}
            >
              <h3 className="font-black text-obsidian text-5xl md:text-3xl xl:text-3xl 2xl:text-5xl">
                {
                  story.content?.explore_full_collection?.content?.[0]
                    ?.content?.[0]?.text
                }{" "}
                <br />
                {
                  story.content?.explore_full_collection?.content?.[1]
                    ?.content?.[0]?.text
                }{" "}
                {
                  story.content?.explore_full_collection?.content?.[2]
                    ?.content?.[0]?.text
                }{" "}
                <br />
                <span className="text-paloverde">
                  {
                    story.content?.explore_full_collection?.content?.[3]
                      ?.content?.[0]?.text
                  }
                </span>
              </h3>
              <SecondaryButton
                text="Shop Now"
                link="/collections/thread-on-filters"
                className="align-left"
                buttonStyle="obsidian"
              />
            </div>
          </div>
        </div>

        {/* product highlight below */}
        {productHighlightsBelow}

        {/* featured collections */}
        <div className={`${style.featuredCollections} my-20`}>
          <h2 className="text-center text-obsidian text-4xl font-black mb-20">
            {story.content.feature_collection_description}
          </h2>
          <div className="flex flex-col md:flex-row w-[90vw] m-auto justify-center">
            {FeaturedCollectionItem}
          </div>
        </div>
        <div
          className={`${style.adventureAssurance}relative flex flex-col items-center justify-end md:justify-center`}
        >
          <img
            src="https://cdn.shopify.com/s/files/1/1050/9944/files/AdventureAssurance_Block_1x_7875ab46-ea69-46f1-8d8a-f2b827fbbff0.webp?v=1659560802"
            className="hidden sm:hidden md:block w-screen m-0"
          />
          <img
            src="https://cdn.shopify.com/s/files/1/1050/9944/files/AdventureAssurance_Block_Mobile_1x_5a54e69b-97e8-4353-a950-bab7ebbcfef3.webp?v=1659560816"
            className="block sm:block md:hidden w-screen m-0"
          />
          <div
            className={`${style.data} absolute text-white w-[100%] px-[20px] md:pl-0 md:w-[50vw] lg:w-[30vw] left-0 md:left-[12.5vw] pb-20 md:pb-0`}
          >
            <h3 className="font-black mb-2 text-3xl md:text-md lg:text-3xl">
              {story.content.adventure_assurance}
            </h3>
            <p className="text-sm">
              {story.content.adventure_assurance_description}
            </p>
            {/* <SecondaryButton text="Learn More" link="#" buttonStyle="white" /> */}
          </div>
        </div>
        <div className={style.getNotified}>
          <div className={`${style.xYcenter} ${style.wrapper}`}>
            <h3 className="font-black text-4xl mb-2">
              {story.content.capture_perfection}
            </h3>
            <p className="font-expanded text-sm">
              {story.content.capture_perfection_description}
            </p>
            <div className={style.socials}>
              <ul className="list-none">
                <li>
                  <a
                    className="reset"
                    href={facebook.link}
                    title={facebook.display_name}
                    target="_blank"
                  >
                    <FaFacebookF />
                  </a>
                </li>
                <li>
                  <a
                    className="reset"
                    href={instagram.link}
                    title={instagram.display_name}
                    target="_blank"
                  >
                    <FaInstagram />
                  </a>
                </li>
                <li>
                  <a
                    className="reset"
                    href={youtube.link}
                    title={youtube.display_name}
                    target="_blank"
                  >
                    <FaYoutube />
                  </a>
                </li>
                <li>
                  <a
                    className="reset"
                    href={vimeo.link}
                    title={vimeo.display_name}
                    target="_blank"
                  >
                    <FaVimeoV />
                  </a>
                </li>
                <li>
                  <a
                    className="reset"
                    href={twitter.link}
                    title={twitter.display_name}
                    target="_blank"
                  >
                    <FaTwitter />
                  </a>
                </li>
                <li>
                  <a
                    className="reset"
                    href={tiktok.link}
                    title={tiktok.display_name}
                    target="_blank"
                  >
                    <FaTiktok />
                  </a>
                </li>
              </ul>
            </div>
            <div className={style.klaviyoForm}>
              <KlaviyoNewsletter />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default IndexPage
